import ScalarThemeSwatches_vue_vue_type_script_setup_true_lang_default from "./ScalarThemeSwatches.vue.script.js";
//#region src/components/ScalarThemeSwatches/ScalarThemeSwatches.vue
var ScalarThemeSwatches_default = ScalarThemeSwatches_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarThemeSwatches_default as default };

//# sourceMappingURL=ScalarThemeSwatches.vue.js.map